/**
 * Do not edit directly
 * Generated on Tue, 05 Aug 2025 14:28:15 GMT
 */

export const Neutral0 = "#ffffff";
export const Neutral100 = "#F7F8F8";
export const Neutral200 = "#F0F1F2";
export const Neutral300 = "#E1E3E4";
export const Neutral400 = "#B4BABD";
export const Neutral500 = "#899296";
export const Neutral600 = "#646F75";
export const Neutral700 = "#41484D";
export const Neutral800 = "#2B3134";
export const Neutral900 = "#191C1E";
export const Neutral1000 = "#0E1113";
export const Violet0 = "#ffffff";
export const Violet100 = "#EFEDFF";
export const Violet200 = "#DFDAFF";
export const Violet300 = "#BFB5FF";
export const Violet400 = "#A090FF";
export const Violet500 = "#806BFF";
export const Violet600 = "#6046FF";
export const Violet700 = "#4D38CC";
export const Violet800 = "#3A2A99";
export const Violet900 = "#261C66";
export const Violet1000 = "#130E33";
export const Lime0 = "#ffffff";
export const Lime100 = "#FBFEE6";
export const Lime200 = "#F7FECC";
export const Lime300 = "#EEFC99";
export const Lime400 = "#E6FB66";
export const Lime500 = "#DDF933";
export const Lime600 = "#D5F800";
export const Lime700 = "#AAC600";
export const Lime800 = "#809500";
export const Lime900 = "#556300";
export const Lime1000 = "#2B3200";
export const Orange0 = "#ffffff";
export const Orange100 = "#FFEDE7";
export const Orange200 = "#FFDBCF";
export const Orange300 = "#FFB7A0";
export const Orange400 = "#FF9270";
export const Orange500 = "#FF6E41";
export const Orange600 = "#FF4A11";
export const Orange700 = "#CC3B0E";
export const Orange800 = "#992C0A";
export const Orange900 = "#661E07";
export const Orange1000 = "#330F03";
export const Pink0 = "#ffffff";
export const Pink100 = "#FDE8FD";
export const Pink200 = "#FAD2FB";
export const Pink300 = "#F6A4F7";
export const Pink400 = "#F177F4";
export const Pink500 = "#ED49F0";
export const Pink600 = "#E81CEC";
export const Pink700 = "#BA16BD";
export const Pink800 = "#8B118E";
export const Pink900 = "#5D0B5E";
export const Pink1000 = "#2E062F";
export const Skyblue0 = "#ffffff";
export const Skyblue100 = "#E6FAFD";
export const Skyblue200 = "#CCF6FB";
export const Skyblue300 = "#99ECF7";
export const Skyblue400 = "#66E3F4";
export const Skyblue500 = "#33D9F0";
export const Skyblue600 = "#00D0EC";
export const Skyblue700 = "#00A6BD";
export const Skyblue800 = "#007D8E";
export const Skyblue900 = "#00535E";
export const Skyblue1000 = "#002A2F";
export const Green0 = "#ffffff";
export const Green100 = "#F3F9F3";
export const Green200 = "#E7F4E8";
export const Green300 = "#D2E8D3";
export const Green400 = "#8FC693";
export const Green500 = "#289B3F";
export const Green600 = "#1C7B30";
export const Green700 = "#11521E";
export const Green800 = "#093912";
export const Green900 = "#022105";
export const Green1000 = "#021504";
export const Red0 = "#ffffff";
export const Red100 = "#FFF6F4";
export const Red200 = "#FDEDEA";
export const Red300 = "#FFDAD3";
export const Red400 = "#FDA091";
export const Red500 = "#FB3728";
export const Red600 = "#CC2A1E";
export const Red700 = "#8C1810";
export const Red800 = "#630E08";
export const Red900 = "#3E0502";
export const Red1000 = "#290302";
